/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiRectPlayIcon16Regular = forwardRef('MediaUiRectPlayIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.379 10.273a.25.25 0 0 1-.38-.214V4.942a.25.25 0 0 1 .38-.215l4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 2A2.75 2.75 0 0 0 1 4.75v5.5A2.75 2.75 0 0 0 3.75 13h8.5A2.75 2.75 0 0 0 15 10.25v-5.5A2.75 2.75 0 0 0 12.25 2h-8.5ZM2.5 4.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-5.5Z" })));
});
